export default __webpack_public_path__ + "static/media/ProfileOthersImage.0a897606.png";